import { createAction, props } from '@ngrx/store';

export const LogInfo = createAction('[Logger] Info', props<{ payload: any }>());
export const LogError = createAction('[Logger] Error', props<{ payload: any }>());
export const LogActions = createAction('[Logger] Log Actions');
